import { render, staticRenderFns } from "./HrDossierInfo.vue?vue&type=template&id=8c4a270a&scoped=true&"
import script from "./HrDossierInfo.vue?vue&type=script&lang=js&"
export * from "./HrDossierInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4a270a",
  null
  
)

export default component.exports